/**
 * 미디어쿼리 사이즈 별 Main의 한 섹션 당 썸네일 개수를 반환합니다.
 * @param size
 * @returns number
 */
const getMainListLengthByScreenSize = (size: 'md' | 'lg' | 'xl') => {
  switch (size) {
    case 'md':
      return 12;
    case 'lg':
      return 15;
    case 'xl':
      return 12;
    default:
      return 12;
  }
};

export default getMainListLengthByScreenSize;
